import axios from 'axios';
import { url } from './url';
import queryStringUtil from "query-string";
import moment from "moment";

function queryString(query) {
    var startDate = moment(query.dateRange[0]).format("DD-MM-YYYY HH:mm:ss");
    var endDate = moment(query.dateRange[1]).format("DD-MM-YYYY HH:mm:ss");
    var queryParams = {
        page: query.page,
        pageSize: query.pageSize,
        customer: query.customer,
        partner: query.partner,
        levels: query.levels,
        telemetry: query.telemetry,
        startDate: startDate,
        endDate: endDate
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function getTelemetries(query) {
    var urlString = `${url}/telemetry`;
    return axios
        .get(urlString,{params:query})
        .then(res => {
            return res.data.map((x) => {
                return { name: x.name, displayName: x.displayName };
            });
        });
}

function getAlarmWatches(query) {
    var urlString = `${url}/alarm-transactions-watch?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                alarmWatches: res.data.data
            }
        });
}

export default {
    getAlarmWatches,
    getTelemetries
};